<template>
  <div class="loveraise">
<!--    <van-nav-bar-->
<!--        left-text="返回"-->
<!--        left-arrow-->
<!--        @click-left="onClickLeft"-->
<!--    />-->
    <div class="lovecontent">
      <ul>
        <li v-for="(item,index) in listData" :key="index">
          <div class="lovecontent-left">
            <span >第{{item.rowNum}}名</span>
          </div>

          <div class="lovecontent-right">
            <span>{{item.nickName | nameencry}}捐款了{{item.sumAmount}}元</span>
          </div>

        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {loveBoard} from "../api";
export default {
  name: "Loveraise",
  data(){
    return{
      listData:[]
    }
  },
  created() {
      this.loveBoard()
    },
  methods:{
    async loveBoard(){
      const res = await loveBoard();
      if (res.code === 200){
        this.listData= res.data
      }
    },

      onClickLeft(){
        this.$router.go(-1)
      }
    }
  }


</script>

<style scoped lang="scss">
.loveraise{
  width:100%;
  height: 100%;
  background: url("../assets/lovesort.png");
  background-size: cover;
  .lovecontent{
      width: 100%;
      margin: 0 auto;
      //margin-top: 250px;
      ul{
        width: 90%;
        margin: 0 auto;
        padding-top:400px;
        li{
          width: 90%;
          display: flex;
          padding-bottom: 40px;
          justify-content: space-between;
          margin: 0 auto;
          .lovecontent-left{
            width: 20%;
            text-align: right;
            span{
              color: #887E89;
            }
          }
          .lovecontent-right{
            width: 70%;
            span{
              text-align: center;
              font-size: 34px;
              color: #887E89;
            }

          }
        }
        li:nth-child(-n + 3){
          span{
          color: #A471AA;
          }
        }

      }

    }
}
</style>
